import script from "./StateAppointmentTypeQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./StateAppointmentTypeQuestion.vue?vue&type=script&setup=true&lang=js"

import _style_0 from "./StateAppointmentTypeQuestion.vue?vue&type=style&index=0&id=41dd50ca&inline&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]],['__scopeId',"data-v-41dd50ca"]])

export default __exports__